import * as React from 'react';

import { PlaceholderRegistrationDocument } from './PlaceholderRegistrationDocument';

export const PlaceholderRegistrationDocumentAztecCode = (props: React.SVGProps<SVGSVGElement>) => (
	<>
		<PlaceholderRegistrationDocument />
		<svg
			version="1.1"
			baseProfile="full"
			style={{ position: 'absolute', left: '19%', top: '70%' }}
			{...props}
		>
			<defs>
				<pattern id="img1" patternUnits="userSpaceOnUse" width="50" height="50">
					<image
						href={`${process.env.PUBLIC_URL}/images/aztec.png`}
						x="0"
						y="0"
						width="50"
						height="50"
					/>
				</pattern>
			</defs>
			<path d="M0,0 l0,50 l50,0 l0,-50 l-50,0" fill="url(#img1)" />
		</svg>
	</>
);
